import Component from 'flarum/common/Component';
import { t, currentLocale, defaultLocale } from '../i18n';

/**
 * Melding boven een verhaal dat (nog) niet in de taal van de pagina bestaat: de lezer
 * krijgt dan de Nederlandse tekst, en weet dat ook. attrs: model (met translation()).
 */
export default class TranslationNotice extends Component {
  view() {
    const model = this.attrs.model;
    const status = model && model.translation ? model.translation() : null;
    if (currentLocale() === defaultLocale() || !status || status === 'translated' || status === 'source') return null;

    return (
      <p className="LcTranslationNotice" lang={currentLocale()}>
        <i className="fas fa-language" aria-hidden="true" /> {t(status === 'stale' ? 'i18n.stale' : 'i18n.untranslated')}
      </p>
    );
  }
}
